export default __webpack_public_path__ + "static/media/linkedIn.4e4e8272.svg";